module.exports = __webpack_public_path__ + "static/media/ne-dsgn_logo.cab4b5eb.svg";


//////////////////
// WEBPACK FOOTER
// ./catalog/static/ne-dsgn_logo.svg
// module id = 786
// module chunks = 10